<div #snakeContainer class="snake-container">
  <!-- Warning modal -->
  @if (snakeModalHtml) {
    <div class="snake-modal">
      <div [innerHtml]="snakeModalHtml"></div>
      <button (click)="startGame()">{{ "start-game" | translate }}</button>
    </div>
  }
  <div class="snake-control">
    <!-- Time -->
    <div class="snake-timer">
      {{ timerMinutes > 9 ? timerMinutes : "0" + timerMinutes }}:
      {{ timerSeconds > 9 ? timerSeconds : "0" + timerSeconds }}
    </div>
    <div class="snake-points">
      <span><b>Bytes: </b>{{ bytes }}</span>
      <span><b>bits: </b>{{ bits }}</span>
    </div>
  </div>
  <!-- Game board -->
  <div #snakeBoard class="snake-board">
    @if (boardReady) {
      <div
        #snakeMapContainer
        leaflet
        class="snake-map"
        [leafletOptions]="mapOptions"
      ></div>
    }
    <!-- Comida -->
    <div #food class="snake-food hidden">
      <img src="../../../../assets/img/gateway-icons/arson_marker.svg" />
    </div>
    <!-- Comida mala -->
    @for (element of badFood; track element; let i = $index) {
      <div
        class="snake-food hidden"
        id="bad-food-{{ i }}"
        >
        <img src="../../../../assets/img/gateway-icons/arson_marker_error.svg" />
      </div>
    }
    <!-- Snake head -->
    <div #snakeHead class="snake-head hidden">
      <i class="fas fa-wave-square"></i>
    </div>
    <!-- Snake body -->
    @for (bodyElement of snakeBody; track bodyElement; let i = $index) {
      <div
        class="snake-body hidden"
        id="snake-body-{{ i }}"
        >
        {{ bodyElement[2] }}
      </div>
    }
  </div>
</div>
